import VideoJsAdapter from "./adapters/videojs_adapter";
import ElementAdapter from "./adapters/element_adapter";

export class PlayerTech {
  plugin(){
    return this._plugin;
  }

  init(){
    this._plugin = new VideoJsAdapter(...arguments);
  }

  id(){
    return this.plugin().id(...arguments);
  }

  currentTime(){
    return this.plugin().currentTime(...arguments);
  }

  error(){
    return this.plugin().error(...arguments) || {};
  }

  el(){
    return (new ElementAdapter(this.plugin().el()));
  }

  errorCode(){
    return this.error().code;
  }

  errorMessage(){
    return this.error().message;
  }

  trigger(){
    return this.plugin().trigger(...arguments);
  }

  on(){
    return this.plugin().on(...arguments);
  }

  one(){
    return this.plugin().one(...arguments);
  }

  off(){
    return this.plugin().off(...arguments);
  }

  readyState(){
    return this.plugin().readyState(...arguments);
  }

  networkState(){
    return this.plugin().networkState(...arguments);
  }

  isFullscreen(){
    return this.plugin().isFullscreen(...arguments);
  }

  corruptedVideoFrames(){
    var playbackQuality = this.plugin().getVideoPlaybackQuality();
    return playbackQuality ? playbackQuality.corruptedVideoFrames : undefined;
  }

  creationTime(){
    var playbackQuality = this.plugin().getVideoPlaybackQuality();
    return playbackQuality ? playbackQuality.creationTime : undefined;
  }

  droppedVideoFrames(){
    var playbackQuality = this.plugin().getVideoPlaybackQuality();
    return playbackQuality ? playbackQuality.droppedVideoFrames : undefined;
  }

  bufferedVideoFrames(){
    var playbackQuality = this.plugin().getVideoPlaybackQuality();
    return playbackQuality ? playbackQuality.totalVideoFrames : undefined;
  }

  dispose(){
    return this.plugin().dispose(...arguments);
  }

  muted(){
    return this.plugin().muted(...arguments);
  }

  play(){
    return this.plugin().play(...arguments);
  }

  paused(){
    return this.plugin().paused(...arguments);
  }

  duration(){
    return this.plugin().duration(...arguments);
  }

  pause(){
    return this.plugin().pause(...arguments);
  }

  metadata(){
    return {
      level: this.plugin().level(),
      levels: this.plugin().levels(),
      targetBitrate: this.plugin().currentBandwidth()
    };
  }

  ended(){
    return this.plugin().ended();
  }

  poster(){
    return this.plugin().poster(...arguments);
  }

  volume(){
    return this.plugin().volume(...arguments);
  }

  addChild(){
    return this.plugin().addChild(...arguments);
  }

  controlBar(){
    return this.plugin().controlBar();
  }

  hideControlbar(){
    return this.plugin().hideControlbar();
  }

  addControlBarChild(){
    return this.plugin().controlBar().addChild(...arguments);
  }

  techName(){
    return this.plugin().techName();
  }

  isFlashTech(){
    return this.techName() == "Flash";
  }

  isInAdMode(){
    return this.plugin().adsObject()?.isInAdMode?.();
  }

  isContentResuming() {
    return this.plugin().isContentResuming();
  }

  videoElement(){
    return this.el().el().querySelector('video');
  }

  videoContainer() {
    return this.videoElement().parentElement;
  }

  getCurrentMediaAttribute() {
    if (this.plugin().hasDashObject()) {
      return this.plugin().dashObject().getCurrentMediaAttribute();
    }
    return this.plugin().hlsObject().getCurrentMediaAttribute();
  }

  getBandwidth() {
    return this.getCurrentMediaAttribute().bitrate;
  }

  getQuality() {
    return this.getCurrentMediaAttribute().height + 'p';
  }

  hasStarted() {
    return this.plugin().hasStarted();
  }

  remainingTime() {
    return this.plugin().remainingTime();
  }

  currentSrc() {
    return this.plugin().currentSrc();
  }

  hlsPlaylistMedia() {
    return this.plugin().hlsPlaylistMedia();
  }

  hasDashObject(){
    return this.plugin().hasDashObject();
  }
}

